var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.616 1.66797H6.39102C3.56602 1.66797 1.66602 3.6513 1.66602 6.6013V13.4096C1.66602 16.3513 3.56602 18.3346 6.39102 18.3346H13.616C16.441 18.3346 18.3327 16.3513 18.3327 13.4096V6.6013C18.3327 3.6513 16.441 1.66797 13.616 1.66797Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00982 12.7067C8.82315 12.7067 8.63648 12.6359 8.49398 12.4934L6.51648 10.5159C6.23148 10.2309 6.23148 9.76922 6.51648 9.48505C6.80148 9.20005 7.26232 9.19922 7.54732 9.48422L9.00982 10.9467L12.4498 7.50672C12.7348 7.22172 13.1957 7.22172 13.4807 7.50672C13.7657 7.79172 13.7657 8.25339 13.4807 8.53839L9.52565 12.4934C9.38315 12.6359 9.19648 12.7067 9.00982 12.7067Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.e686c3a317e1861d6a53cbea74ea27c1.svg";
export { ForwardRef as ReactComponent };